export enum RecurrenceType {
  EVERY_N_DAYS = "EVERY_N_DAYS",
  WEEKLY = "WEEKLY",
  BIWEEKLY = "BIWEEKLY",
}

export enum ScheduleWeekDay {
  Mon = "Mon",
  Tue = "Tue",
  Wed = "Wed",
  Thu = "Thu",
  Fri = "Fri",
  Sat = "Sat",
  Sun = "Sun",
}

export enum DayOffRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

export interface StaffScheduleStaffRelation {
  id: string;
  profileId: string;
  position: string;
}

export interface StaffSchedule {
  id: string;
  staffId: string;
  hotelId: string;
  staff: StaffScheduleStaffRelation;
  recurrenceType: RecurrenceType;
  recurrenceInterval: number | null;
  days: ScheduleWeekDay[];
  anchorDate: string;
  startTime: string;
  endTime: string;
  effectiveFrom: string;
  effectiveTo: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateStaffScheduleDto {
  staffId: string;
  hotelId: string;
  recurrenceType: RecurrenceType;
  recurrenceInterval?: number;
  days?: ScheduleWeekDay[];
  anchorDate: string;
  startTime: string;
  endTime: string;
  effectiveFrom: string;
  effectiveTo?: string;
}

export interface UpdateStaffScheduleDto {
  recurrenceType?: RecurrenceType;
  recurrenceInterval?: number;
  days?: ScheduleWeekDay[];
  anchorDate?: string;
  startTime?: string;
  endTime?: string;
  effectiveFrom?: string;
  effectiveTo?: string | null;
}

export interface StaffAvailability {
  staffId: string;
  profileId: string | null;
  isAvailable: boolean;
  startTime: string | null;
  endTime: string | null;
}

export interface StaffAvailabilityCheck {
  staffId: string;
  hotelId: string;
  date: string;
  isAvailable: boolean;
}

export interface DayOffRequest {
  id: string;
  staffId: string;
  hotelId: string;
  startDate: string;
  endDate: string;
  reason: string | null;
  status: DayOffRequestStatus;
  reviewedById: string | null;
  reviewedAt: string | null;
  reviewNote: string | null;
  createdAt: string;
}

export interface CreateDayOffRequestDto {
  hotelId: string;
  startDate: string;
  endDate: string;
  reason?: string;
}

export interface StaffAvailabilityDay {
  date: string;
  isAvailable: boolean;
  startTime: string | null;
  endTime: string | null;
  hasDayOff: boolean;
  hasDayOffRequest: boolean;
  tasksCount: number;
}

export interface StaffAvailabilityRange {
  staffId: string;
  profileId: string | null;
  isOnline: boolean;
  photoId: string | null;
  firstName: string | null;
  lastName: string | null;
  position: string | null;
  teamName: string | null;
  totalTasks: number;
  days: StaffAvailabilityDay[];
}

export interface ScheduleStats {
  totalTasks: number;
  totalTasksCancelled: number;
  totalPeopleOnSite: number;
}

export interface ReviewDayOffRequestDto {
  status: DayOffRequestStatus.APPROVED | DayOffRequestStatus.REJECTED;
  reviewNote?: string;
}
